import React, { useState } from 'react';
import { LoaderOn, openNotification, ANTD_COMPONENTS } from 'tt-ui-lib/core';
import { AddPhotoIcon, ANTD_ICONS } from 'tt-ui-lib/icons';
import { useMutation } from '@apollo/client';
import { v1 as uuidv1 } from 'uuid';
import axios from 'axios';
import styles from './Uploader.module.scss';
import AvatarCropModal from '../../AvatarCropModal/AvatarCropModal';
import { GET_URL_FOR_PUBLIC_UPLOAD } from '../../../constants/api';

const { Avatar } = ANTD_COMPONENTS;
const { UserOutlined } = ANTD_ICONS;

const AvatarSignupUploader = ({ avatarSrc, changeAvatar, error, helperText }) => {
  const [avatar, setAvatar] = useState(null);
  const [fileToS3, setFileToS3] = useState(null);
  const [avatarFile, setAvatarFile] = useState(null);
  const [isAvatarModal, setIsAvatarModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [getPublicUrl] = useMutation(GET_URL_FOR_PUBLIC_UPLOAD, {
    variables: { input: { fileToS3 } },
  });

  const uploadFile = async (file) => {
    try {
      setIsLoading(true);

      const formatFile = file?.name.substr(-4, 4);
      let filesName;
      if (formatFile === '.') {
        filesName = `${uuidv1()}.${file?.name}${formatFile}`;
      } else {
        filesName = `${uuidv1()}.${file?.name}`;
      }
      const path = `avatars`;
      const toUpload = { path: path, name: filesName };
      setFileToS3(toUpload);
      const { data } = await getPublicUrl({ variables: { input: toUpload } });
      setFileToS3(null);
      const urlToUpload = data?.getUrlForPublicUpload?.url;

      const putData = await axios.put(urlToUpload, file, {
        headers: {
          'Content-type': file.type,
          'Access-Control-Allow-Origin': '*',
        },
      });
      if (putData.statusText === 'OK') {
        changeAvatar(`${toUpload.name}`);
      } else {
        openNotification({
          message: 'Error while uploading file.',
          type: 'error',
        });
      }

      setIsLoading(false);
    } catch (e) {
      openNotification({
        message: 'Error while uploading file.',
        type: 'error',
      });
      setIsLoading(false);
    }
  };

  const handleUpdateAvatar = async (file) => {
    Object.assign(file, {
      preview: URL.createObjectURL(file),
    });
    setAvatar(file);
    await uploadFile(file);
  };

  const openCropModal = (e) => {
    const file = e.target.files[0];
    const filesize = (file.size / 1024 / 1024).toFixed(2);

    if (filesize <= 2) {
      setAvatarFile(file);
      setIsAvatarModal(true);
    } else {
      openNotification({
        message: 'Allowed files with 2MB or below.',
        type: 'info',
      });
    }
    e.target.value = null;
  };

  return (
    <>
      <div className={styles.avaDiv}>
        <Avatar
          icon={<UserOutlined />}
          src={avatar?.preview || avatarSrc}
          size={128}
          className={error ? styles.errorAvatar : ''}
        />

        <div
          className={styles.avaButton}
          onClick={() => document.getElementById('avatar-file-input').click()}
        >
          <AddPhotoIcon style={{ width: 20, height: 20 }} />
          <input
            id="avatar-file-input"
            onChange={openCropModal}
            type="file"
            hidden
            accept=".png, .jpg, .jpeg"
          />
        </div>

        {isLoading && <LoaderOn />}
      </div>

      {helperText && <div className={styles.errorMessage}>{helperText}</div>}

      {isAvatarModal && (
        <AvatarCropModal
          open={isAvatarModal}
          setOpen={setIsAvatarModal}
          avatarFile={avatarFile}
          setAvatar={handleUpdateAvatar}
        />
      )}
    </>
  );
};

export default AvatarSignupUploader;
